/**
 * @generated SignedSource<<1dfee546ccadf3c26bb4b95fc50428f9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type fallback_nativeIssueTable_FallbackCell$data = {
  readonly id?: string;
  readonly renderedFieldHtml: string | null | undefined;
  readonly type: string;
  readonly " $fragmentType": "fallback_nativeIssueTable_FallbackCell";
};
export type fallback_nativeIssueTable_FallbackCell$key = {
  readonly " $data"?: fallback_nativeIssueTable_FallbackCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"fallback_nativeIssueTable_FallbackCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "fallback_nativeIssueTable_FallbackCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    }
  ],
  "type": "JiraFallbackField"
};

(node as any).hash = "f6db480e9fa3aceb9daa6c2c472e9fac";

export default node;
